<script setup lang="ts">
import { ShieldX } from 'lucide-vue-next';
import { onMounted } from 'vue';

onMounted(() => {
  document.title = 'Acesso Negado';
});
</script>

<template>
  <div class="mt-5 row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body text-center py-5">
          <div class="mb-4">
            <ShieldX class="icon icon-5 text-danger" />
          </div>
          <h2 class="mb-3">Acesso Negado</h2>
          <p class="text-secondary mb-4">
            Você não possui as permissões necessárias para acessar esta página.
            Entre em contato com o administrador do sistema se acredita que isso é um erro.
          </p>
          <div class="d-flex gap-2 justify-content-center">
            <button
              type="button"
              class="btn btn-primary"
              @click="$router.go(-1)"
            >
              Voltar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="$router.push('/')"
            >
              Ir para Início
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
